import * as React from 'react';
import { Box } from '@leagueplatform/genesis-core';
import { ErrorState } from '@leagueplatform/web-common-components';

export function ErrorPage() {
  return (
    <Box
      css={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <ErrorState headingString="We’re sorry, we can’t find the page you’re looking for." />
    </Box>
  );
}
